module.exports = __webpack_public_path__ + "static/img/quantity.9e59c2b1.png";